import T from 'i18n-react';
import { Language } from './constants';
import _merge from 'lodash/merge';
import { Constants } from '../../../services/util/Constants';

class Lang {
    constructor() {
        const translationData = require('../../../resources/data/dict.json');
        const linksData = require('../../../resources/data/links.json');
        const errorData = require('../../../resources/data/errors.json');

        this.combinedData = _merge(translationData, linksData, errorData);
        this.currentLang = Language.ENGLISH;
        T.setTexts(this.combinedData, { MDFlavor: 1 });
    }

    setCurrentLanguage(lang) {
        if (lang && (lang.toUpperCase() === Language.ENGLISH || lang.toUpperCase() === Language.FRENCH)) {
            this.currentLang = lang;
        }
    }

    getCurrentLanguage() {
        return this.currentLang;
    }

    getValue(key, language, params) {
        key = this.getKey(key, language);
        return T.translate(key, params);
    }

    getKey(key, language) {
        if (key.includes(Constants.DS_DELIMITER)) {
            var index = key.indexOf(Constants.DS_DELIMITER);
            return(`${key.substring(0, index)}.${language.toLowerCase()}`);
        }
        return (`${key}.${language.toLowerCase()}`);
    }

    getCurrentValue(key, params) {
        key = this.getKey(key, this.currentLang)
        return T.translate(key, params);
    }

    addCustomDictionary(dictionary) {
        const combinedDict = _merge(this.combinedData, dictionary)
        T.setTexts(combinedDict, { MDFlavor: 1})
    }

    resetDictionaries() {
        T.setTexts(this.combinedData, { MDFlavor: 1 });
    }

    loadCustomDictionary(dictionary) {
        T.setTexts(dictionary, { MDFlavor: 1 })
    }
}

const lang = new Lang();
export default lang;